import React from "react";
import { Container, VideoBox } from "./styles";

export const Video = ({ data }) => {
  return (
    <Container>
      <VideoBox autoPlay muted loop playsInline src={data} />
    </Container>
  );
};
